export const en = {
    timezone: 'Time zone'
};
